<template>
  <el-dialog
    width="500px"
    title="订单信息"
    :visible="visible"
    :lock-scroll="false"
    :destroy-on-close="true"
    append-to-body
    custom-class="ele-dialog-form"
    @update:visible="updateVisible">
    <el-form :model="form" label-width="80px" size="small" @keyup.enter.native="save" @submit.native.prevent>
      <el-form-item label="失败原因">
        <el-input clearable v-model.trim="form.remark" placeholder="请输入" />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="updateVisible(false)">取消</el-button>
      <el-button type="primary" :loading="loading" @click="save">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'TuisEdit',
  props: {
    visible: Boolean,
    data: Object
  },
  data() {
    return {
      form: { id: null, remark: '' },
      loading: false
    };
  },
  watch: {
    visible(val) {
      if (!val) this.loading = false;
    },
    data: {
      immediate: true,
      handler(row) {
        this.form = {
          id: row && row.id ? row.id : null,
          remark: ''
        };
      }
    }
  },
  methods: {
    save() {
      if (this.loading || !this.form.id) return;
      this.loading = true;
      this.$http
        .post('/Outorder/updateStatus', {
          id: this.form.id,
          order_status: 2,
          remark: this.form.remark || ''
        })
        .then((res) => {
          this.loading = false;
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.updateVisible(false);
            this.$emit('done');
            return;
          }
          this.$message.error(res.data.msg);
        })
        .catch((e) => {
          this.loading = false;
          this.$message.error(e.message);
        });
    },
    updateVisible(value) {
      this.$emit('update:visible', value);
    }
  }
};
</script>
